var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04011 11.9044C6.43271 8.82502 6.12901 7.28534 6.78616 6.03261C7.4433 4.77988 8.85564 4.20615 11.6803 3.05868L12.2559 2.82487C14.3899 1.95797 15.4569 1.52452 16.1009 2.08431C16.7449 2.64409 16.518 3.80785 16.0643 6.13537L14.0439 16.5H7.9466L7.04011 11.9044Z",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 19.25C5.5 17.9536 5.5 17.3055 5.90273 16.9027C6.30546 16.5 6.95364 16.5 8.25 16.5H13.75C15.0464 16.5 15.6945 16.5 16.0973 16.9027C16.5 17.3055 16.5 17.9536 16.5 19.25V20.1667H5.5V19.25Z",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66669 20.1666L18.3334 20.1666",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.6271eebf0cf33e4a4fbfe8732e336de2.svg";
export { ForwardRef as ReactComponent };